import React, { useEffect, useState } from 'react';
import { Button, Container, Grid, makeStyles } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';

import MUIDataTable from 'mui-datatables';
import { parse } from 'node-html-parser';
import Page from '@components/template/Page';
import { Functions, Database } from '@config/Firebase';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const StockRecommendView = () => {
  const classes = useStyles();
  /**
   * @author Won
   */
  const [recommendItems] = useState([]),
    [registeredPosts, setRegisteredPosts] = useState([]),
    [refinedData, setRefinedData] = useState([]),
    refMui = React.createRef();

  const findAll = () => {
    Functions.httpsCallable('getBlogRssFeed')().then(async feed => {
      const items = feed.data.rss.channel.item;
      const excutableData = [];
      for (let i = 0, size = items.length; i < size; i++) {
        const keys = Object.keys(items[i]);
        const refineFeed = {};
        for (let j = 0, keysLength = keys.length; j < keysLength; j++) {
          if (typeof items[i][keys[j]] === 'object') {
            const temp = items[i][keys[j]];
            refineFeed[keys[j]] = temp.__cdata;
          } else {
            refineFeed[keys[j]] = items[i][keys[j]];
          }

          if (keys[j] === 'link') {
            const splitLink = items[i][keys[j]].split('/');
            const blogData = await Functions.httpsCallable('getBlogData')({
              uuid: splitLink[splitLink.length - 1]
            }).then(data => data);
            const _rawHtml = parse(blogData.data);
            const image = _rawHtml.querySelector('.se-image-resource');
            if (image) {
              const rawAttrs = image.rawAttrs,
                imageUrl = rawAttrs.substring(
                  rawAttrs.indexOf('src') + 5,
                  rawAttrs.indexOf('?type')
                );

              refineFeed['thumbnailUrl'] = `${imageUrl}?type=w966`;
            }
          }
        }
        excutableData.push(refineFeed);
      }
      debugger;
      Database.ref('recommendStocks/').set(excutableData);
    });
  };

  const columns = ['제목', '관련종목'];

  const options = {
    filter: true,
    filterType: 'dropdown',
    searchOpen: true,
    searchPlaceholder: '여기에 검색하세요',
    download: false,
    print: false,
    rowsSelected: refinedData.map((item, index) => (item.isPost ? index : ''))
  };

  const handleClickSave = async () => {
    // console.log('::: REF :::',refMui.current.state.selectedRows.data)
    // const selectedIndex = refMui.current.state.selectedRows.data;
    // const res = await Database.ref('recommendStocks/').set(
    //   selectedIndex.map(item => recommendItems[item.index])
    // );
    // console.log(res)
    alert('저장되었습니다.');
    // selectedIndex.map(item=> recommendItems[item.index]).map(item => {
    //   console.log("input item", item)
    // })
  };

  useEffect(() => {
    findAll();
    // console.log("root:", Database.ref('/'))
    Database.ref('recommendStocks/')
      .once('value')
      .then(snapshot => setRegisteredPosts(snapshot.val()));
  }, []);

  useEffect(() => {
    if (registeredPosts?.length && recommendItems?.length) {
      setRefinedData(
        recommendItems.map(crawledItem => {
          const isPost = !!registeredPosts.filter(
            regItem => crawledItem.title === regItem.title
          ).length;

          return {
            ...crawledItem,
            isPost: isPost
          };
        })
      );
    }
  }, [registeredPosts, recommendItems]);

  return (
    <Page className={classes.root} title="StockRecommendView">
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            추천종목 관리
          </Grid>
          <Grid item xs={12}>
            {refinedData && (
              <MUIDataTable
                ref={refMui}
                options={options}
                columns={columns}
                data={refinedData.map(item => [item.title, item.tag])}
              />
            )}
            <Button
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => handleClickSave()}
            >
              저장하기
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default StockRecommendView;
